import {BankCategory} from "@/modules/finances/enums";
import {BankLog} from "@/modules/finances/entity/BankLog";
import {inject, injectable} from "inversify";
import {Season} from "@/modules/season/entity";
import {EventEmitter} from "@/modules/base/events";
import {Application} from "@/di";

type BankLogType = { category: BankCategory, amount: number, label?: string };

@injectable()
export class Bank {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
    @inject(Application) private application: Application,
  ) {
  }

  public async log(data: BankLogType) {
    const log = new BankLog();
    log.category = data.category;
    log.amount = data.amount;
    log.label = data.label;
    log.season = await Season.current();
    log.createdAt = log.season.currentDateRaw;
    await log.save();
  }
}